/**
 * Lo que todavía no se le muestra al cliente.
 *
 * NO es código muerto: Insights, Informe IA, Diagnóstico de Catálogo y la vista
 * vieja de productos vinculados están construidos y a medio terminar (o
 * reemplazados, en el caso de los vinculados: el destino Productos es «Cómo está
 * cada producto», plan 3 · P3-D2). Se esconden por decisión explícita —no por
 * evidencia de uso, que no medimos— y vuelven cuando se cierren.
 *
 * Se enciende con VITE_MOSTRAR_EN_DESARROLLO=1 para trabajar en ellas.
 */
export const MOSTRAR_EN_DESARROLLO = import.meta.env.VITE_MOSTRAR_EN_DESARROLLO === '1';

/**
 * La pestaña «Análisis» de Estrategias de Mercado.
 *
 * Escondida temporalmente a pedido del dueño (7-oct): hace ruido. Volver a true para mostrarla.
 *
 * En false: no se ve la pestaña, no se monta su contenido y un enlace con
 * `?destino=analisis` cae en el destino por omisión (Hoy). El código de Análisis
 * queda entero: con true todo vuelve a funcionar como antes.
 */
export const PESTANA_ANALISIS_VISIBLE = false;
